import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "../lib/api";
import Turnstile, { TURNSTILE_ENABLED } from "../components/Turnstile";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [token, setToken] = useState("");
  const tsRef = useRef(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email, turnstile_token: token });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
      setToken("");
      tsRef.current?.reset();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="max-w-5xl w-full mx-auto px-6 pt-8">
        <Link to="/" className="flex items-center gap-3 w-fit">
          <span className="solera-symbol" />
          <span className="wordmark text-bone text-sm">Solera</span>
        </Link>
      </header>
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md rise" data-testid="forgot-password-panel">
          <span className="t-label">Reset your password</span>
          {sent ? (
            <p className="t-small text-muted-s mt-6" data-testid="forgot-password-sent">
              Request recorded. If the account exists, Solera will contact you directly with a
              reset link. We never send account links from any domain other than solera.vc.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4">
              <input className="input-solera" type="email" placeholder="Email" value={email}
                onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
              {error && <p className="t-small status-blocked">{error}</p>}
              <Turnstile ref={tsRef} onToken={setToken} />
              <button className="btn-primary w-full" disabled={busy || (TURNSTILE_ENABLED && !token)} data-testid="forgot-submit-button">
                {busy ? "Recording" : "Request reset"}
              </button>
            </form>
          )}
          <p className="t-cap text-muted-s mt-8">
            <Link to="/login" className="link-plain" data-testid="forgot-login-link">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
